// src/AudioRecognition/util/note.ts
export function hzToMidi(hz: number): number {
  return 69 + 12 * Math.log2(hz / 440);
}
export function midiToHz(midi: number): number {
  return 440 * Math.pow(2, (midi - 69) / 12);
}
const NAMES = ['C', 'C#', 'D', 'D#', 'E', 'F', 'F#', 'G', 'G#', 'A', 'A#', 'B'];
export function midiToName(midi: number): string {
  const n = Math.round(midi);
  const name = NAMES[((n % 12) + 12) % 12];
  const oct = Math.floor(n / 12) - 1;
  return `${name}${oct}`;
}
export function hzToName(hz: number | null | undefined): string | null {
  if (!hz || hz <= 0) return null;
  return midiToName(hzToMidi(hz));
}
